module.exports = __webpack_public_path__ + "img/rentals.86325c0.svg";